import CampoSeletor from '@/components/Formulario/CampoSeletor';
import CampoTexto from '@/components/Formulario/CampoTexto';
import Grid, { GridItem } from '@/components/layout/Grid';
import CampoMultiTexto from '@/components/Formulario/CampoMultiTexto';
import CampoMultiSeletor from '@/components/Formulario/CampoMultiSeletor';
import CampoNumero from '@/components/Formulario/CampoNumero';
import {
  NetworkWanDTO,
  NetworkWanTypeDTO,
} from '@webip/shared/src/dto/appliance';

const usoOptions: { id: string, label: string }[] = [
  { id: 'primario', label: 'Primário' },
  { id: 'backup', label: 'Backup' }
];

export const FormWan = ({
  value,
  onChange,
  fieldErrors,
  availablePorts,
}: {
  value: NetworkWanDTO;
  onChange: (v: NetworkWanDTO) => void;
  fieldErrors: any;
  availablePorts: string[];
}) => {
  const isVlan = (value?.vlan ?? 0) > 0;
  return (
    <Grid>
      <div style={{ position: 'absolute', height: 0 }}>
        <input
          type="text"
          name="username"
          style={{
            height: 0,
            width: 0,
            border: 'none',
            outline: 'none',
            margin: 0,
            padding: 0,
          }}
        />
        <input
          type="password"
          name="password"
          style={{
            height: 0,
            width: 0,
            border: 'none',
            outline: 'none',
            margin: 0,
            padding: 0,
          }}
        />
      </div>
      <GridItem sm={12}>
        <CampoTexto
          value={value?.nome ?? ''}
          onChange={v => onChange({ ...value, nome: v })}
          label="Nome"
          error={fieldErrors?.nome}
        />
      </GridItem>
      <GridItem sm={6}>
        <CampoSeletor
          value={value?.uso ?? ''}
          onChange={v => onChange({ ...value, uso: v as any })}
          label="Uso"
          options={usoOptions}
          error={fieldErrors?.uso}
        />
      </GridItem>
      <GridItem sm={6}>
        <CampoNumero
          value={value?.prioridade?.toString() ?? '0'}
          onChange={v => onChange({ ...value, prioridade: v ? +v : 0 })}
          label="Prioridade"
          error={fieldErrors?.prioridade}
          hint="Menor = maior prioridade na lista de failover"
        />
      </GridItem>
      <GridItem sm={12} md={4}>
        <CampoNumero
          value={value?.vlan?.toString() ?? '0'}
          onChange={v => onChange({ ...value, vlan: v ? +v : 0 })}
          label="ID VLAN"
          hint={isVlan ? 'VLAN sobre a interface-base ao lado' : '0 = interface dedicada'}
          error={fieldErrors?.vlan}
        />
      </GridItem>
      <GridItem sm={12} md={8}>
        <CampoMultiSeletor
          options={availablePorts.map(it => ({ label: it, id: it }))}
          value={value?.portas}
          onChange={v => onChange({ ...value, portas: v })}
          label={isVlan ? 'Interface base (VLAN trunk)' : 'Portas'}
          error={fieldErrors?.portas}
        />
      </GridItem>
      <GridItem sm={12}>
        <CampoSeletor
          noSearch
          options={[
            { label: 'Estático', id: 'estatico' },
            { label: 'DHCP', id: 'dhcp' },
            { label: 'PPPoE', id: 'pppoe' },
          ]}
          value={value?.tipoWan ?? ''}
          onChange={v =>
            onChange({
              ...value,
              tipoWan: v as NetworkWanTypeDTO,
            } as NetworkWanDTO)
          }
          label="Tipo"
          error={fieldErrors?.tipoWan}
        />
      </GridItem>
      {value?.tipoWan == 'estatico' && (
        <>
          <GridItem sm={12}>
            <CampoMultiTexto
              value={value?.ips}
              onChange={v =>
                onChange({
                  ...value,
                  ips: v,
                })
              }
              label="IPs/Subnets"
              error={fieldErrors?.ips}
              placeholder="Ex: 192.168.88.1"
            />
          </GridItem>
          <GridItem sm={12}>
            <CampoTexto
              value={value?.gateway ?? ''}
              onChange={v => onChange({ ...value, gateway: v })}
              label="Gateway"
              error={fieldErrors?.gateway}
              placeholder="Ex: 192.168.88.254"
            />
          </GridItem>
        </>
      )}
      {value?.tipoWan == 'pppoe' && (
        <>
          <GridItem sm={12}>
            <CampoTexto
              value={value?.pppoe_usuario ?? ''}
              onChange={v => onChange({ ...value, pppoe_usuario: v })}
              label="Usuário"
              error={fieldErrors?.pppoe_usuario}
            />
          </GridItem>
          <GridItem sm={12}>
            <CampoTexto
              value={value?.pppoe_senha ?? ''}
              onChange={v => onChange({ ...value, pppoe_senha: v })}
              label="Senha"
              error={fieldErrors?.pppoe_senha}
            />
          </GridItem>
        </>
      )}
    </Grid>
  );
};
